// Telemetry counts as "live" only if an `update` WS message arrived within
// this window. Without it, a vehicle that stops publishing keeps its last
// state forever and the OFFLINE grey-out in VehicleIcon never fires. The
// window must be comfortably above the telemetry publish cadence (~1s) so an
// actively streaming vehicle never flickers grey when the heartbeat tracker
// is wrong (e.g. the amqp-to-cloud-core-processor is down).
export const TELEMETRY_FRESHNESS_MS = 30_000;

export const isTelemetryFresh = (
  receivedAt: number | undefined,
  now: number = Date.now()
): boolean => !!receivedAt && now - receivedAt < TELEMETRY_FRESHNESS_MS;
